import { render } from "./MyPageBookmark.vue?vue&type=template&id=1eb20f62"
import script from "./MyPageBookmark.vue?vue&type=script&lang=js"
export * from "./MyPageBookmark.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__